import { LeftOutlined } from "@ant-design/icons"
import { Flex, Layout, Progress, Tabs, Typography, notification } from "antd"
import { useEffect, useState } from "react";

import Rep from "./Rep";
import { useNavigate, useParams } from "react-router-dom";
import API from "../../../../API";
import useRepsTabs from "../../../../Hooks/useRepsTabs";
import { GuardarPruebaProvider } from "../../../../Contexts/GuardarPrueba/GuardarPrueba";
import GuardarPruebaPanel from "../../../../Componentes/Pruebas/GuardarPruebaPanel";

const { Header } = Layout

const NordicGuardar = () => {
    const {id} = useParams()
    const navigate = useNavigate()
    const [cargando,setCargando]=useState(false)
    const [atleta,setAtleta] = useState({})
    const { reps, repActual, setRepActual, agregarRep, onEdit } = useRepsTabs(Rep, atleta);

    const cargarAtleta=async ()=>{
        try{
            setCargando(true)
            const {data} = await API(`atleta/${id}`)
            setAtleta(data.doc)
        }catch(error){
            notification.error({description:error.response.data.mensaje})
            navigate('/atletas')
        }finally{
            setCargando(false)
        }
    }

    useEffect(()=>{
        cargarAtleta()
    },[])

    useEffect(()=>{
        if(atleta?._id){
            agregarRep()
        }
    },[atleta])

    return (
        <GuardarPruebaProvider>
            <Flex vertical style={{ flex: 1 }}>
                <Header>
                    <Flex gap="middle" justify="space-between" align="center" style={{ height: '100%' }}>
                        <Flex gap="middle">
                            <LeftOutlined onClick={()=>navigate(-1)}/>
                            <Typography.Text>{atleta?.nombre}</Typography.Text>
                            <Typography.Text type="secondary">{atleta?.peso}kg {(atleta?.peso/0.45359237).toFixed(2)}lbs</Typography.Text>
                        </Flex>
                        <Typography.Title level={5}>Curl Nórdico</Typography.Title>
                        <Flex gap="middle" justify="center" align="center">
                            <img width={16} src="/imagenes/bateria.png" alt="" />
                            <div style={{ width: 150 }}>
                                <Progress percent={40} status="active" steps={10} size="small" />
                            </div>
                        </Flex>
                    </Flex>
                </Header>
                <GuardarPruebaPanel atleta={atleta} tipoPrueba="Nordic" repsTabs={reps} />
                <Tabs
                    style={{paddingTop:8}}
                    type="editable-card"
                    items={reps}
                    onChange={setRepActual}
                    onEdit={onEdit}
                    activeKey={repActual}
                />
            </Flex>
        </GuardarPruebaProvider>
    )
}

export default NordicGuardar
